import { AlphaGCircleIcon } from './AlphaGCircleIcon';

/**
 * author: Contributors
 * id 5DB072AE-CE38-4FA8-A41D-0C7443DA3481
 * name alpha-g-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-g-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterGCircleIcon = AlphaGCircleIcon;
export default LetterGCircleIcon